// 組み込みロールの集合。`User.role` には組織ごとに作るカスタム権限 (`custom_` 接頭辞、PolicyUserRole の name) も
// 入るので、`User.role` の値域全体ではない。backend 側の正本は packages/backend/infra の Prisma enum `UserRole` で、
// frontend は backend パッケージに依存できないため同じ値集合を別定義している。
export const BUILTIN_USER_ROLES = {
  admin: 'admin', // SALESCORE 社の CS メンバー。組織のユーザー一覧には出さない
  manager: 'manager',
  playingManager: 'playingManager',
  member: 'member',
  minimal: 'minimal', // 全権限 off のメンバー (SST ユーザー専用)。admin 画面でのみ設定できる
  guest: 'guest', // deprecated。client の招待フォームでは選択肢から外しているが、既存ユーザーには残っている
  nxMember: 'nxMember', // NX 様向けの、ビュー保存ができない一般メンバー
} as const

export type BuiltInUserRole = (typeof BUILTIN_USER_ROLES)[keyof typeof BUILTIN_USER_ROLES]
